import * as React from "react";

const ChevronRight: React.FC = () => {
    return <svg width="8px" height="12px" viewBox="0 0 8 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-448.000000, -361.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(367.000000, 131.000000)">
                    <polygon points="2.25 10.6 6.95 6 2.25 1.4 3.65 0 9.75 6 3.65 12"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(ChevronRight);
